import React, { useEffect, useState } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  Button,
  Form,
  FormGroup,
  Label,
  Col,
} from "reactstrap";
import { Colxx, Separator } from "components/common/CustomBootstrap";
import { toast } from "react-toastify";
import Select from "react-select";

import { useToken } from "auth/useToken";
import { useUser } from "auth/useUser";
import axios from "axiosClient";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import moment from "moment";

const FeedbackModal = (props) => {
  const { toggle } = props;
  const user = useUser();

  const initialValues = {
    testDate: "",
    venue: "",
  };

  const [values, setValues] = useState(initialValues);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [testDate, setTestDate] = useState(null);
  const [id, setId] = useState(null);

  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!values.subject || !values.type || !values.message) {
      return toast.error("Please fill all the required fields");
    }
    setLoading(true);
    axios
      .post(`/api/partners/create-feedback`, {
        ...values,
        testDate: testDate ? moment(testDate).format("DD/MM/YYYY") : null,
      })
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          setErrorMessage("");
          setId(result.data.id);
          setSuccess(true);
        } else {
          toast.error("Something went wrong. Try again later");
        }
        setLoading(false);
      })
      .catch((err) => {
        // console.log(err.response.data);
        toast.error(
          err.response.data.message || "Something went wrong. Try again later"
        );
        setLoading(false);
      });
  };

  return (
    <div>
      <Row>
        <Colxx xxs="12">
          <div className="mb-2">
            <h1>Feedback Form</h1>
          </div>
          <Separator className="mb-5" />
        </Colxx>
      </Row>

      <Row className="text-left">
        <Colxx xxs="12" className="mb-4">
          <Card className="mb-4">
            <CardBody>
              {success ? (
                <>
                  <h2>You feedback has been submitted.</h2>
                  <p>
                    The reference number is <b>{id}</b>
                  </p>
                </>
              ) : (
                <Form>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>
                          Subject<span className="text-red"> *</span>
                        </Label>
                        <Select
                          className="react-select"
                          classNamePrefix="react-select"
                          name="subject"
                          value={{
                            label: values.subject,
                            value: values.subject,
                          }}
                          onChange={(e) => {
                            setValues({ ...values, subject: e.value });
                          }}
                          options={[
                            {
                              label: "Venue Condition",
                              value: "Venue Condition",
                            },
                            {
                              label: "Customer Service",
                              value: "Customer Service",
                            },
                            {
                              label: "Technical Issue",
                              value: "Technical Issue",
                            },
                            {
                              label: "Other",
                              value: "Other",
                            },
                          ]}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>
                          City<span className="text-red"> *</span>
                        </Label>
                        <Select
                          className="react-select"
                          classNamePrefix="react-select"
                          name="city"
                          value={{ label: values.city, value: values.city }}
                          onChange={(e) => {
                            setValues({ ...values, city: e.value });
                          }}
                          options={[
                            { label: "Tashkent", value: "Tashkent" },
                            {
                              label: "Tashkent Region",
                              value: "Tashkent Region",
                            },
                            { label: "Andijan", value: "Andijan" },
                            { label: "Bukhara", value: "Bukhara" },
                            { label: "Fergana", value: "Fergana" },
                            { label: "Jizzakh", value: "Jizzakh" },
                            { label: "Namangan", value: "Namangan" },
                            { label: "Navoiy", value: "Navoiy" },
                            { label: "Qashqadaryo", value: "Qashqadaryo" },
                            { label: "Samarqand", value: "Samarqand" },
                            { label: "Sirdaryo", value: "Sirdaryo" },
                            { label: "Surxondaryo", value: "Surxondaryo" },
                            { label: "Xorazm", value: "Xorazm" },
                            {
                              label: "Karakalpakstan",
                              value: "Karakalpakstan",
                            },
                          ]}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>
                          Choose the Test<span className="text-red"> *</span>
                        </Label>
                        <Select
                          className="react-select"
                          classNamePrefix="react-select"
                          name="type"
                          value={{ label: values.type, value: values.type }}
                          onChange={(e) => {
                            setValues({ ...values, type: e.value });
                          }}
                          options={[
                            { label: "Main Test", value: "Main Test" },
                            {
                              label: "Speaking",
                              value: "Speaking",
                            },
                          ]}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Test Date (if applicable)</Label>
                        <DatePicker
                          className={"form-control"}
                          calendarIcon={<i className="simple-icon-calendar" />}
                          clearIcon={<i className="iconsminds-close" />}
                          dayPlaceholder="DD"
                          monthPlaceholder="MM"
                          yearPlaceholder="YYYY"
                          format="dd/MM/y"
                          minDate={
                            new Date(
                              new Date().setFullYear(
                                new Date().getFullYear() - 100
                              )
                            )
                          }
                          value={testDate ? testDate : null}
                          showLeadingZeros={true}
                          shouldOpenCalendar={({ reason }) =>
                            reason !== "focus"
                          }
                          onChange={(v) => {
                            setTestDate(v);
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Venue name (if applicable)</Label>
                        <Input
                          type="text"
                          name="venue"
                          value={values.venue}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    <Col md="12">
                      <FormGroup>
                        <Label>
                          Describe the situation/problem with the details
                          <span className="text-red"> *</span>
                        </Label>
                        <Input
                          type="textarea"
                          name="message"
                          value={values.message}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              )}
              <div>
                <Button
                  color="light"
                  className="top-right-button"
                  onClick={toggle}
                >
                  Close
                </Button>

                <Button
                  color={success ? "success" : "primary"}
                  className="top-right-button ml-2"
                  onClick={handleSubmit}
                  disabled={success || loading}
                >
                  Submit
                </Button>
              </div>
              <div>{errorMessage}</div>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    </div>
  );
};

export default FeedbackModal;
